<div *transloco="let t" class="flex flex-col gap-6" [formGroup]="form">
  <label tuiLabel>
    {{ t('Nom du télésuivi') }}
    <tui-textfield>
      <input data-testid="request-name" formControlName="name" ngDefaultControl tuiInput [placeholder]="defaultName" />
    </tui-textfield>
    <tui-error formControlName="name" />
  </label>
  <label tuiLabel tuiLabelRequired>
    {{ t('Ajouter un message') }}
    <tui-textfield>
      <textarea
        data-testid="request-message"
        formControlName="message"
        tuiTextarea
        [minRows]="3"
        [placeholder]="t('Saisir un message personnalisé (facultatif)')"></textarea>
    </tui-textfield>
    <tui-error formControlName="message" />
  </label>

  @if (creatorType === CreatorType.BY_PATIENT) {
    <div class="flex flex-col gap-6">
      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -- the control is a component whose native input the rule cannot see -->
      <label tuiLabel>
        <span class="required">{{ t('Formulaire à compléter par le patient') }}</span>
        <pxc-form-select data-testid="patient-form" formControlName="patientForm" ngDefaultControl />
        <tui-error formControlName="patientForm" />
      </label>

      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -- the control is a component whose native input the rule cannot see -->
      <label tuiLabel>
        <span class="required">{{ t('Langue du patient') }}</span>
        <pxc-telemonitoring-locale-picker
          data-testid="patient-locale-code"
          formControlName="localeCode"
          ngDefaultControl />
        <tui-error formControlName="localeCode" />
      </label>

      <div>
        <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -- the control is a component whose native input the rule cannot see -->
        <label tuiLabel>
          <span class="required">{{ t('Numéro de téléphone du patient') }}</span>
          <pxc-patient-contact-input
            data-testid="patient-contact"
            formControlName="patientContact"
            ngDefaultControl
            [clientCode]="clientCode"
            [countryIsoCode]="localeCode | localeFlag | uppercase"
            [patientId]="patientId" />
        </label>
        <tui-error formControlName="patientContact" />
        <p class="mt-2 text-sm text-text-tertiary">
          {{ t('Le patient recevra des rappels pour documenter son télésuivi') }}
        </p>
      </div>

      <div>
        <p class="mb-1 max-w-prose text-sm font-medium">{{ t('Notifier le patient') }}</p>
        <label tuiLabel>
          <input
            data-testid="should-send-text-message-to-patient"
            formControlName="shouldSendTextMessageToPatient"
            tuiCheckbox
            type="checkbox" />
          <p class="text-base text-text-tertiary">{{ t('Envoyer un SMS au patient à la création du télésuivi') }}</p>
          <tui-error formControlName="shouldSendTextMessageToPatient" />
        </label>
        <label class="mt-1" tuiLabel>
          <div class="flex items-center">
            <input
              data-testid="enable-automatic-reminder-for-inactive-patient"
              formControlName="enableAutomaticReminderForInactivePatient"
              tuiCheckbox
              type="checkbox" />
            <p class="ml-1 flex items-center gap-2 text-base text-text-tertiary">
              {{ t('Activer la relance automatique lorsque le patient est inactif pendant') }}
              <ng-container>
                <tui-textfield class="w-16 text-center" tuiTextfieldSize="s">
                  <input
                    formControlName="reminderDaysInterval"
                    ngDefaultControl
                    tuiInputNumber
                    [attr.aria-label]="t('Nombre de jours où le patient est inactif')"
                    [min]="1"
                    [readOnly]="isReminderDaysIntervalReadOnly" />
                </tui-textfield>
              </ng-container>
              {{ t('jours') }}
            </p>
          </div>
          <tui-error formControlName="reminderDaysInterval" ngDefaultControl />
        </label>
      </div>
    </div>
  }
</div>
